import { createContext, useContext, useState, useEffect, useCallback } from "react";
import { api, USER_TOKEN_KEY } from "../lib/api";

const AuthContext = createContext(null);
export const useAuth = () => useContext(AuthContext);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null); // null = checking, false = anon, object = authed

  const checkAuth = useCallback(async () => {
    // If returning from Google OAuth, let AuthCallback establish the session first.
    if (window.location.hash?.includes("session_id=")) return;
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(false);
    }
  }, []);

  useEffect(() => {
    checkAuth();
  }, [checkAuth]);

  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    localStorage.setItem(USER_TOKEN_KEY, data.access_token);
    await checkAuth();
    return data;
  };

  const login = async (payload) => {
    const { data } = await api.post("/auth/login", payload);
    localStorage.setItem(USER_TOKEN_KEY, data.access_token);
    await checkAuth();
    return data;
  };

  const logout = async () => {
    try { await api.post("/auth/logout"); } catch { /* ignore */ }
    localStorage.removeItem(USER_TOKEN_KEY);
    setUser(false);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, register, login, logout, refresh: checkAuth }}>
      {children}
    </AuthContext.Provider>
  );
}
